import { MessageCircle } from "lucide-react";

const NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER;
const MESSAGE = "Olá, vi o vosso site e queria saber mais sobre a simulação da minha piscina.";

function normalise(n) {
  return (n || "").replace(/[^0-9]/g, "");
}

export default function WhatsAppButton() {
  const num = normalise(NUMBER);
  if (!num) return null;
  const href = `https://wa.me/${num}?text=${encodeURIComponent(MESSAGE)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      className="fixed bottom-6 left-6 z-40 group"
      aria-label="Falar no WhatsApp"
    >
      <span className="relative flex items-center gap-3 bg-ink text-bone px-4 py-3 transition-all duration-500 hover:bg-pool-deep">
        <span className="absolute -inset-0.5 bg-pool/30 -z-10 opacity-0 group-hover:opacity-100 blur-md transition-opacity duration-500" />
        <MessageCircle size={18} strokeWidth={1.5} />
        <span className="overline text-[10px]">WhatsApp</span>
      </span>
    </a>
  );
}
